function CardEspacoWall() {
    return (
        <div className="card-container">
            <div className='text-block'>
                <h1 className='piso-name'>Painel Ripado</h1>
                <div className='garantia'>
                    <span>Período de Garantia Residencial</span>
                    <div className='garantia-info'>
                        <h1 className='garantia-numero'>5</h1>
                        <span className='garantia-meses'>anos</span>
                    </div>
                </div>
                <hr />
                <div className='garantia'>
                    <span>Período de Garantia Comercial</span>
                    <div className='garantia-info'>
                        <h1 className='garantia-numero'>5</h1>
                        <span className='garantia-meses'>anos</span>
                    </div>
                </div>
            </div>


            <div className='text-block'>
                <h1 className='piso-name'>Revestimento Lastra</h1>
                <div className='garantia'>
                    <span>Período de Garantia Residencial</span>
                    <div className='garantia-info'>
                        <h1 className='garantia-numero'>5</h1>
                        <span className='garantia-meses'>anos</span>
                    </div>
                </div>
                <hr />
                <div className='garantia'>
                    <span>Período de Garantia Comercial</span>
                    <div className='garantia-info'>
                        <h1 className='garantia-numero'>5</h1>
                        <span className='garantia-meses'>anos</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CardEspacoWall;